import React from "react";
import GameLoginPopup from "./GameLoginPopup";
import ShareCodePopup from "./ShareCodePopup";
import SecretCodeLoginPopup from "./SecretCodeLoginPopup";
import AwardQueryPopup from "./AwardQueryPopup";

// import "./antd-override.scss";
// import "./index.scss";

interface PopupInfo {
  /**
   * 弹窗类型
   * gameLogin ：游戏账号登录
   * share ：分享码查看
   * award ：奖励兑换码查询
   * secretCodeLogin ：神秘代码登录
   */
  type: "gameLogin" | "share" | "secretCodeLogin" | "award";
  open: boolean;
  onClose: () => void;
  onSuccess: () => void;
  shareCode?: string; // 分享码，仅用于 share 类型
  tips?: string; // 提示信息，显示在页面下方
  showButton?: boolean; // 是否显示按钮，默认为 true
}

/**
 * 统一的弹窗组件，根据类型渲染不同的子组件
 * 使用组合模式，每个弹窗类型都有独立的组件
 */
const Popup: React.FC<PopupInfo> = ({
  open,
  onClose,
  onSuccess,
  type,
  shareCode,
  tips,
  showButton = true,
}) => {
  // 根据类型渲染对应的弹窗组件
  const renderPopup = () => {
    switch (type) {
      case "gameLogin":
        return (
          <GameLoginPopup
            open={open}
            onClose={onClose}
            onSuccess={onSuccess}
            showButton={showButton}
          />
        );

      case "share":
        return (
          <ShareCodePopup
            open={open}
            onClose={onClose}
            shareCode={shareCode}
            showButton={showButton}
          />
        );

      case "secretCodeLogin":
        return (
          <SecretCodeLoginPopup
            open={open}
            onClose={onClose}
            onSuccess={onSuccess}
            showButton={showButton}
          />
        );

      case "award":
        return <AwardQueryPopup open={open} onClose={onClose} />;

      default:
        return null;
    }
  };

  return (
    <>
      {open && (
        <>
          {renderPopup()}
          {/* {tips && (
            <div className='popup-tips'>
              <div className='tips-content'>{tips}</div>
            </div>
          )} */}
        </>
      )}
    </>
  );
};

export default Popup;
